export enum QueryOutputType {
    arrayOfObjects = 'arrayOfObjects',
    arrayOfArrays = 'arrayOfArrays',
}
